export const cn = (...x: Array<string | false | null | undefined>) => x.filter(Boolean).join(' ');

export function fmtDateShort(d: string | number | Date): string {
  return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function fmtDateMed(d: string | number | Date): string {
  return new Date(d).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

export function daysUntil(d: string | number | Date): number {
  return Math.max(0, Math.ceil((new Date(d).getTime() - Date.now()) / 86400000));
}

export function partyColor(p?: string | null): string {
  if (!p) return '#6B7280';
  const k = p.toLowerCase();
  if (k.includes('democrat')) return '#3B6BD9';
  if (k.includes('republican')) return '#D33C3C';
  if (k.includes('independ')) return '#1F9A55';
  if (k.includes('green')) return '#3F7C44';
  if (k.includes('libertarian')) return '#C9742B';
  return '#6B7280';
}

export function initialsOf(name?: string | null): string {
  if (!name) return '?';
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join('');
}
